import styled from "styled-components";

export const StyledInput = styled.section`
	height: 100vh;
	background-image: white;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	background-size: cover;
`